module.exports = __webpack_public_path__ + "img/arrow-inactive.f7841fa2.svg";